class AnimatedSearchPlaceholder {
  constructor(element) {
    this.element = element;
    this.input = element.closest('.field')?.querySelector('.field__input');
    this.prefix = 'Search for ';
    this.terms = (element.dataset.terms || '')
      .split(',')
      .map((term) => term.trim())
      .filter(Boolean);

    if (!this.input || this.terms.length === 0) return;

    this.termIndex = 0;
    this.charIndex = 0;
    this.timeoutId = null;
    this.paused = true;

    this.input.addEventListener('blur', this.maybeResume.bind(this));
    this.input.addEventListener('input', this.maybeResume.bind(this));
    this.input.form?.addEventListener('reset', () => setTimeout(this.maybeResume.bind(this)));

    this.maybeResume();
  }

  pause() {
    this.paused = true;
    clearTimeout(this.timeoutId);
  }

  maybeResume() {
    if (this.input.value.length > 0) {
      this.pause();
      this.element.textContent = '';
      return;
    }

    if (this.paused) {
      this.paused = false;
      this.type();
    }
  }

  type() {
    if (this.paused) return;
    const current = this.terms[this.termIndex];

    if (this.charIndex <= current.length) {
      this.element.textContent = this.prefix + current.slice(0, this.charIndex);
      this.charIndex += 1;
      this.timeoutId = setTimeout(this.type.bind(this), 55);
      return;
    }

    this.timeoutId = setTimeout(this.erase.bind(this), 1400);
  }

  erase() {
    if (this.paused) return;
    const current = this.terms[this.termIndex];

    if (this.charIndex > 0) {
      this.charIndex -= 1;
      this.element.textContent = this.prefix + current.slice(0, this.charIndex);
      this.timeoutId = setTimeout(this.erase.bind(this), 28);
      return;
    }

    this.termIndex = (this.termIndex + 1) % this.terms.length;
    this.timeoutId = setTimeout(this.type.bind(this), 400);
  }
}

document.querySelectorAll('[data-animated-placeholder]').forEach((element) => {
  new AnimatedSearchPlaceholder(element);
});
